const features = [
  {
    title: 'TreeVault Cloud',
    description:
      'Automatic backups and cross-device sync so your research stays safe—laptop, desktop, or tablet.',
  },
  {
    title: 'Charts & Reports',
    description:
      'Pedigree, descendant, and fan charts with clean layouts ready to print or share as keepsakes.',
  },
  {
    title: 'Media Library',
    description:
      'Attach photos, documents, and recordings to every person, then find them with fast search.',
  },
  {
    title: 'Smart Matching',
    description:
      'Color coding and duplicate detection help you merge records without losing careful work.',
  },
  {
    title: 'FamilySync Hints',
    description:
      'Connect to FamilySearch and surface likely ancestor matches that deepen your discoveries.',
  },
  {
    title: 'FamilySearch Tools',
    description:
      'Search, attach, and verify records inside Family Tree Maker as new features roll out.',
  },
];

export default function Features() {
  return (
    <section className="t7-section t7-section--white" id="about">
      <div className="container">
        <div className="t7-head t7-head--rail">
          <p className="t7-kicker">About the software</p>
          <h2 className="t7-title">Welcome to Family Tree Maker</h2>
          <p className="t7-lead">
            Trusted genealogy tools with an interface that grows with you—from your first ancestor
            to a full family network spanning generations.
          </p>
        </div>

        <div className="t7-features-grid">
          {features.map((feature, index) => (
            <article key={feature.title} className="t7-feature-cell group">
              <span className="block text-xs font-bold tracking-[0.16em] text-[#15803d] mb-2 sm:mb-3">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="font-serif text-lg sm:text-xl text-[#14201a] mb-2 sm:mb-3 group-hover:text-[#166534] transition-colors">
                {feature.title}
              </h3>
              <p className="text-[#4d5c54] text-sm sm:text-[15px] leading-relaxed m-0">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
